/** Breadcrumb for a Service Bus source: its name from the cached detail query, else the ID. */
import { useQuery } from '@tanstack/react-query'
import { IdCrumb } from '@/shell/crumbs'
import { sourceQuery } from './api'

export function SourceCrumb({ params }: { params: Record<string, string> }) {
  const id = params.sourceId ?? ''
  const q = useQuery({ ...sourceQuery(id), enabled: !!id })
  return q.data ? <span>{q.data.name}</span> : <IdCrumb value={id} />
}
